/* unplugin-vue-components disabled */
// TODO: refactor to store
import {Rest} from 'utils'
import {API2_CONTACTS} from 'consts/api2'
import ContactSuggestion from './contact-suggestion.vue'
const MIN_LENGTH = 2

export default {
  components: {ContactSuggestion},
  mixins: [ModelValue(Object)],
  props: {
    required: {type: Boolean, default: true},
    placeholder: {type: String, default: undefined},
    teleported: {type: Boolean, default: false},
    userId: {type: String, default: undefined},
    hideFollowed: {type: Boolean, default: false},
    companyName: {type: String, default: undefined}
  },
  data() {
    return {
      el_value: undefined,
      rest: new Rest(),
      last_query: '',
      last_res: []
    }
  },
  computed: {
    empty() {
      return !Object.keys(this.value).length
    }
  },
  methods: {
    focus() {
      this.$refs.el_autocomplete.focus()
    },
    async loadAsync(query, cback) {
      const linkedin_id = this.getLinkedinId(query)
      if (linkedin_id) return cback([])

      if (!query || query.length < MIN_LENGTH) return cback([])
      if (this.last_query === query) {
        return cback(this.last_res)
      }

      let query_params = {query: query}
      if (this.userId && this.hideFollowed) {
        query_params['user_id'] = this.userId
        query_params['hide_followed'] = this.hideFollowed
      }
      if (this.companyName){
        query_params['company_name'] = this.companyName
      }
      const view_items = await this.rest.get(`${API2_CONTACTS}/search`, query_params)
      if (!view_items?.length) {
        this.last_query = query
        this.last_res = []
        return cback([])
      }

      const res = []
      for (let comp of view_items) {
        res.push({
          key: `${comp.name} (${comp.linkedin_id})`,
          ...comp
        })
      }
      
      this.last_query = query
      this.last_res = res
      cback(res)
    },
    onInput(query) {
      this.resetInput()
      const linkedin_id = this.getLinkedinId(query)
      if (linkedin_id) {
        this.value = {linkedin_id}
      }
    },
    onSelect(item) {
      this.value = item
    },
    abortAll() {
      this.rest.abortAll()
    },

    getLinkedinId(query){
      const match = query.match(/linkedin\.com\/(?:in)\/([a-zA-Z0-9'%.-]+)/i)
      return match
        ? match[1].replace(/\/$/, '')
        : false
    },
    resetInput(){
      this.abortAll()
      this.$refs.el_autocomplete.suggestions = []
      this.value = undefined
      this.last_res = []
      this.last_query = ''
    },
    clear(){
      this.resetInput()
      this.$refs.el_autocomplete.close()
      this.el_value = undefined
    }
  }
}
